export class STAConverter {
  static convertToSTA(statements) {
    let staContent = '';

    statements.forEach(statement => {
      // Nagłówek wyciągu - uproszczony format STA
      const firstTransaction = statement.transactions[0];
      const lastTransaction = statement.transactions[statement.transactions.length - 1];

      if (firstTransaction && lastTransaction) {
        staContent += `:20:${lastTransaction.valueDate}\n`;
        staContent += `:25:${statement.account.replace('PL', '')}\n`;
        staContent += `:28C:${this.generateTimestamp()}\n`;
        staContent += `:60F:${statement.openingBalance}\n`;
      }

      // Konwersja każdej transakcji
      statement.transactions.forEach(transaction => {
        staContent += this.convertTransaction(transaction);
      });

      // Saldo końcowe
      staContent += `:62F:${statement.closingBalance}\n`;
    });

    return staContent;
  }

  static convertTransaction(transaction) {
    // Format uproszczony STA - linia :61: i :86:
    let result = '';

    // Linia :61: z podstawowymi danymi transakcji (zamiana kropek na przecinki w kwotach)
    const amount = transaction.amount.replace('.', ',');
    result += `:61:${transaction.valueDate}${transaction.entryDate}${transaction.debitCredit}${amount}\n`;

    // Linia :86: z opisem transakcji
    const description = this.buildTransactionDescription(transaction);
    result += `:86:${description}\n`;

    return result;
  }

  static buildTransactionDescription(transaction) {
    const info = transaction.additionalInfo;
    const description = info.fullText || info.description || '';

    // Dla transakcji depozytowych ARD
    if (description.includes('ARD') && description.includes('DEP')) {
      if (description.includes('SPŁ')) {
        const periodInfo = this.extractPeriodInfo(description);
        const tnr = this.extractTNR(description);
        return `ARD SPŁ. DEP. PLN; ${periodInfo} KONTRAHENT: 539229001; ZWIĄZEK HARCERSTWA POLSKIEGO; TNR: ${tnr}`;
      } else {
        const rateAndPeriod = this.extractRateAndPeriod(description);
        return `ARD DEP. PLN; ${rateAndPeriod} SPŁ. KAPITAŁU: 33114010100000539229001110; WYP. ODSETEK: 06114010100000539229`;
      }
    }

    // Dla opłat grupowych
    if (description.includes('OPŁATY GRUPOWE')) {
      return `OPŁATY GRUPOWE ; TNR: ${this.extractTNR(description)}`;
    }

    // Dla pozostałych transakcji
    let result = '';

    // Nazwa kontrahenta i adres
    if (info.counterpartyName) {
      result += info.counterpartyName;
      if (info.counterpartyAddress) {
        result += ' ' + info.counterpartyAddress;
      }
    }

    // Numer rachunku
    if (info.accountNumber) {
      result += ' ' + info.accountNumber;
    }

    // Tytuł płatności
    if (info.remittanceInfo) {
      result += ' ' + info.remittanceInfo;
    }

    return result.trim();
  }

  static extractRateAndPeriod(description) {
    const rateMatch = description.match(/OPROC\.:\s*([0-9.,]+%)/);
    const periodMatch = description.match(/OD:\s*([0-9.]+)\s+DO:\s*([0-9.]+)/);

    let result = '';
    if (rateMatch) {
      result += `OPROC.: ${rateMatch[1]}; `;
    }
    if (periodMatch) {
      result += `OD: ${periodMatch[1]} DO: ${periodMatch[2]};`;
    }

    return result;
  }

  static extractPeriodInfo(description) {
    const periodMatch = description.match(/OD:\s*([0-9.]+)\s+DO:\s*([0-9.]+)/);
    if (periodMatch) {
      return `OD: ${periodMatch[1]} DO: ${periodMatch[2]};`;
    }
    return '';
  }

  static extractTNR(description) {
    const tnrMatch = description.match(/TNR:\s*([0-9.]+)/);
    return tnrMatch ? tnrMatch[1] : '';
  }


  static generateTimestamp() {
    const now = new Date();
    const year = now.getFullYear().toString();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');

    return year + month + day;
  }

  static generateFileName(statements) {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');

    // Wyciągnij ostatnie 4 cyfry z numeru rachunku
    let accountSuffix = '1110'; // domyślnie
    if (statements && statements.length > 0 && statements[0].account) {
      const account = statements[0].account.replace('PL', '');
      accountSuffix = account.slice(-4);
    }

    // Wyciągnij miesiąc i rok z pierwszej transakcji
    let statementMonth = month;
    let statementYear = year;
    if (statements && statements.length > 0 && statements[0].transactions.length > 0) {
      const firstTransaction = statements[0].transactions[0];
      const dateStr = firstTransaction.valueDate; // format YYMMDD

      if (dateStr.length === 6) {
        const transactionYear = parseInt('20' + dateStr.substring(0, 2));
        const transactionMonth = dateStr.substring(2, 4);

        statementMonth = transactionMonth;
        statementYear = transactionYear;
      }
    }

    return `${accountSuffix}_${statementMonth}_${statementYear}_${year}${month}${day}.sta`;
  }
}